var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2428 13.045C21.4016 12.9568 21.5 12.7895 21.5 12.6079C21.5 12.4263 21.4016 12.259 21.2428 12.1708L18.9605 10.9029C14.464 8.4048 9.72391 6.37279 4.81421 4.83851L4.14914 4.63067C3.99732 4.58323 3.83198 4.61085 3.70383 4.70507C3.57568 4.79929 3.5 4.94885 3.5 5.10791V10.8579C3.5 11.1238 3.70816 11.3432 3.97372 11.3572L4.98336 11.4104C7.44497 11.5399 9.89156 11.8738 12.2979 12.4085L12.5362 12.4615C12.5892 12.4733 12.6122 12.4949 12.625 12.5122C12.6411 12.5339 12.6536 12.5673 12.6536 12.6079C12.6536 12.6485 12.6411 12.682 12.625 12.7037C12.6122 12.7209 12.5892 12.7426 12.5362 12.7543L12.2979 12.8073C9.89157 13.342 7.44496 13.6759 4.98334 13.8055L3.97372 13.8586C3.70816 13.8726 3.5 14.092 3.5 14.3579V20.1079C3.5 20.267 3.57568 20.4165 3.70383 20.5108C3.83198 20.605 3.99732 20.6326 4.14914 20.5852L4.81422 20.3773C9.72391 18.843 14.464 16.811 18.9605 14.313L21.2428 13.045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send_message.dd3925114e6a8fe76aa1cd97aa9a2453.svg";
export { ForwardRef as ReactComponent };